    // Show the first tab by default
$('.tabs-stage > div').hide();
$('.tabs-stage > div:first').show();
$('.tabs-nav li:first').addClass('tab-active');

// Change tab class and display content
$('.tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.tabs-stage > div').hide();
  $($(this).attr('data-href')).show(); 
});

$(window).scroll(function() {
  if ($(this).scrollTop() > 30){
    $('.mobile-menu').addClass("small");
  } else {
    $('.mobile-menu').removeClass("small");
  }
}); 